<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Entry or Exit Flow Graph"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('entry_exit_external')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Exit or Entry Flow
      (External) Tool.
    </div>

    <!-------------------- EXTRY AND EXIT FLOW GRAPH HELP GUIDE -------------------->
    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Admin Support (External)
          <i class="fa-solid fa-arrow-right"></i> Entry or Exit Flow Graph
        </h1>

        <h3 class="h3-second-header">
          Initial results with default form values
        </h3>

        <ul class="unordered-list">
          <li>
            Once you get to the page, results will automatically generate based
            on the default values in the Exit or Entry Flow Graph form fields.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Goal for Entry or Exit Flow tool</h3>

        <ul class="unordered-list">
          <li>
            Analyze the flow of students in and out of colleges, departments,
            and programs based on cohorts.
          </li>
          <li>
            The chart display the flow of students moving in and out depending
            on the chosen form fields parameters.
          </li>
          <li>
            The table display student details based on the chosen form fields
            parameters.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">
          Entry or Exit Flow Graph Form Submission
        </h3>

        <ol class="ordered-list">
          <li>Select a cohort [Default: 2020]</li>
          <li>Select a category [Default: College]</li>
          <li>
            Select a direction (Forward: Flow out; Backward: Flow in) [Default:
            Forward]
          </li>
          <li>
            Select an Entry/Exit [Default: Arts, Social Sciences and Humanities]
          </li>
          <li>Select the range for high school GPA [Default: 0 - 5.04]</li>
          <li>Select a year range [Default: from 1 to 2]</li>
        </ol>
      </div>

      <div class="left-align-div">
        <p></p>
        <div>
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageEntryExitFlow39External']"
            alt=""
          />
          <p class="picture-caption">
            Figure 39: Default inputs for Exit or Entry Flow Graph form
          </p>
        </div>
      </div>

      <div class="left-align-div">
        <p></p>
        <div>
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageEntryExitFlow40External']"
            alt=""
          />
          <p class="picture-caption">Figure 40: Exit or Entry Flow Graph</p>
        </div>
      </div>

      <div class="left-align-div">
        <p></p>
        <div>
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageEntryExitFlow40aExternal']"
            alt=""
          />
          <p class="picture-caption">
            Figure 40a: Exit or Entry Flow Graph Details
          </p>
        </div>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Results after Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After submitting the form, you will see 1 Sankey graph like the
            screenshot (Figure 40) above that shows you the exit or entry flow
            of students for the selected form field values.
          </li>
          <li>
            You will also see a table below the graph that is the flow graph
            data table filtered by cohort and entry/exit.
          </li>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageEntryExitFlow41External']"
              alt=""
            />
            <p class="picture-caption">
              Figure 41: Entry or Exit Flow Graph Data Table
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getExternalAdminSupportRelatedLinkBasedOnTool(
        'Entry or Exit Flow Graph',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
